import React from 'react'
import { Button, ListGroup, ListGroupItem, Card, CardHeader, CardBody } from 'reactstrap'
import { getName } from './TitlePrinter'
import '../styles/Location.css'

function nextTenantKnown(state) {
  let nextTenant;
  if(state.nextTenantKnown){
    nextTenant = <li>Nachmieter: {getName(state.NextTenant)} </li>
  }

  return (
    <div>
      {nextTenant}
    </div>
  );
}

export default props => (
    <ListGroup>
            {props.LocationCancellations.map((cancellation, index) =>
                <ListGroupItem key={index}>
                  <Card id="card">
                    <CardHeader id="cardHeader">
                      Vertragskontonummer {cancellation.metertype==='gas'? 'Erdgas' : 'Strom'}: {cancellation.accountnumber}
                      <Button className="float-right" onClick={props.HandleCancellationRemoval} id={cancellation.meternumber} ><i className="fa fa-close"></i></Button>
                    </CardHeader>
                    <CardBody>
                      <ul>
                        <li>Zählernummer: {cancellation.meternumber} </li>
                        <li>Zählerstand: {cancellation.meterreading} </li>
                        <li>Lieferende: {cancellation.deliveryEndDate.split("-").reverse().join(".")}</li>
                        <li>Straße: {cancellation.street} {cancellation.housenumber} {cancellation.housenumberextension}</li>
                        <li>Ort: {cancellation.postcode} {cancellation.city}</li>
                        {nextTenantKnown(cancellation)}
                      </ul>
                    </CardBody>
                  </Card>
                </ListGroupItem>
            )}
    </ListGroup>
)


// WEBPACK FOOTER //
// ./src/components/RegisteredCancellations.js